import { listPayouts, payoutCountFun } from '../../../api/superAdmin';
import errorHandle from '../../../utils/errorHandle';

export const fetchPaymentsData = async (setLoading, setPaymentsData, type, status, limit, offset) => {
    setLoading(true);
    try {
        const res = await listPayouts(type, status, limit, offset);
        setPaymentsData(res.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const payoutsCount = (setTotalCount, type, status, setLoading) => {
    setLoading(true);
    try {
        payoutCountFun(type, status).then((res) => {
            setLoading(false);
            setTotalCount(status === 'approved' ? res.data['approved'] : res.data['not-approved']);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
